import space from '@/client/components/theme/space'
import styled from 'styled-components'

export const WrapCalculator = styled.div`
  position: relative;
  padding-top: ${space.xl5};
`
